<template>
  <div class="bg-white dark:bg-jevi-dark w-full flex flex-col justify-center items-center h-screen pt-3">
    <div class=" sm:w-8/12 lg:w-4/6 xl:w-9/12">
      <div class="w-full sm:w-4/5 flex flex-col sm:flex-row items-center justify-around">
        <img class="mx-auto w-2/5 sm:w-1/5 object-scale-down" :src="
          theme === 'dark'
            ? '/static/logo_darkmode.png'
            : '/static/logo_lightmode.png'
        " />

        <div class="w-full sm:w-3/5 px-5 flex flex-col items-center justify-end my-3">
          <h1 class="text-xl text-center md:text-left md:text-2xl text-black dark:text-white mb-2">
            {{ $i18n.t("last_posts") }}
          </h1>

          <div class="flex gap-2">
            <p class="text-sm my-auto text-black dark:text-white">
              {{ $i18n.t("want_to_see_more") }}
            </p>
            <t-button class="bg-primary-1000" @click="$router.push('/login')">{{
                $i18n.t("login")
            }}</t-button>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full sm:w-2/3 h-full overflow-y-auto">
      <div class="mt-5 w-full sm:w-4/5 mx-auto">
        <t-card v-for="(element, index) in posts" :variant="theme === 'dark' ? 'dark' : 'light'" class="mt-5"
          :key="'feed-post-' + element.id" :style="element.type === 2 ? 'aspect-ratio: 16/9' : ''"
          style="background-color: transparent; box-shadow: none;">
          <template v-slot:header>
            <div class="pb-2 px-6">
              <div class="w-full flex justify-between">
                <div class="flex">
                  <div class="w-16 h-16">
                    <profile-picture :data="element.user" :sizePx="128" />
                  </div>

                  <div class="ml-3 my-auto">
                    <p class="text-black dark:text-white text-sm sm:text-md" style="display: flex; align-items: center">
                      {{ element.user.username }}
                      <span class="ml-1" v-if="element.user.verified == 1">
                        <img src="/static/user_verified.png" style="{ display: flex; height: 16px; width: 16px; }" />
                        <!--<font-awesome-icon class="mt-2 mb-0 my-0" icon="check-circle" style="color: #6a71ec; font-size: 16px" />-->
                      </span>
                    </p>
                    <p class="text-gray-400 text-sm sm:text-md">
                      {{ element.created_at | fromNow }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <img v-if="element.type === 1 && element.url_picture" :alt="element.text"
            class="mx-auto object-cover px-2 py-2" src="/static/logo_square.png" :ref="'loading-picture-' + element.id"
            style="aspect-ratio: 1" />
          <template v-if="element.type === 4 && element.post_photos.length > 0">
            <div class="flex flex-col">
              <!-- 1 picture case -->

              <div class="mx-auto my-auto" v-if="element.post_photos.length === 1">
                <img v-if="element.post_photos[0].url_picture" :alt="element.text"
                  class="mx-auto object-cover px-2 py-2" src="/static/logo_square.png"
                  :ref="'loading-picture-poll-' + element.post_photos[0].id" />
                <img :alt="element.text" v-if="element.post_photos[0].url_picture" style="border-radius: 15px"
                  class="hidden mx-auto object-cover px-2 py-2" @load="onPollImageLoad(element.post_photos[0].id)"
                  :src="compressedImage(element.post_photos[0])" :ref="'poll-' + element.post_photos[0].id" />
              </div>
              <!-- 2 pictures case -->

              <div class="mx-auto w-full flex" v-if="element.post_photos.length === 2">
                <div class="w-1/2 my-auto">
                  <img v-if="element.post_photos[0].url_picture" :alt="element.text"
                    class="mx-auto object-cover px-1 py-1" src="/static/logo_square.png"
                    :ref="'loading-picture-poll-' + element.post_photos[0].id" />
                  <img :alt="element.text" v-if="element.post_photos[0].url_picture" style="border-radius: 15px"
                    class="hidden mx-auto object-cover px-1 py-1" @load="onPollImageLoad(element.post_photos[0].id)"
                    :src="compressedImage(element.post_photos[0])" :ref="'poll-' + element.post_photos[0].id" />
                </div>
                <div class="w-1/2 my-auto">
                  <img v-if="element.post_photos[1].url_picture" :alt="element.text"
                    class="mx-auto object-cover px-1 py-1" src="/static/logo_square.png"
                    :ref="'loading-picture-poll-' + element.post_photos[1].id" />
                  <img :alt="element.text" v-if="element.post_photos[1].url_picture" style="border-radius: 15px"
                    class="hidden mx-auto object-cover px-1 py-1" @load="onPollImageLoad(element.post_photos[1].id)"
                    :src="compressedImage(element.post_photos[1])" :ref="'poll-' + element.post_photos[1].id" />
                </div>
              </div>

              <!-- 3 pictures case -->

              <div class="mx-auto flex" v-if="element.post_photos.length === 3">
                <div class="w-1/3 my-auto">
                  <img v-if="element.post_photos[0].url_picture" :alt="element.text"
                    class="mx-auto object-cover px-1 py-1" src="/static/logo_square.png"
                    :ref="'loading-picture-poll-' + element.post_photos[0].id" />
                  <img :alt="element.text" v-if="element.post_photos[0].url_picture"
                    class="hidden mx-auto object-cover px-1 py-1" style="border-radius: 10px"
                    @load="onPollImageLoad(element.post_photos[0].id)" :src="compressedImage(element.post_photos[0])"
                    :ref="'poll-' + element.post_photos[0].id" />
                </div>
                <div class="w-1/3 my-auto">
                  <img v-if="element.post_photos[1].url_picture" :alt="element.text"
                    class="mx-auto object-cover px-1 py-1" src="/static/logo_square.png"
                    :ref="'loading-picture-poll-' + element.post_photos[1].id" />
                  <img :alt="element.text" v-if="element.post_photos[1].url_picture"
                    class="hidden mx-auto object-cover px-1 py-1" style="border-radius: 10px"
                    @load="onPollImageLoad(element.post_photos[1].id)" :src="compressedImage(element.post_photos[1])"
                    :ref="'poll-' + element.post_photos[1].id" />
                </div>
                <div class="w-1/3 my-auto">
                  <img v-if="element.post_photos[2].url_picture" :alt="element.text"
                    class="mx-auto object-cover px-1 py-1" src="/static/logo_square.png"
                    :ref="'loading-picture-poll-' + element.post_photos[2].id" />
                  <img :alt="element.text" v-if="element.post_photos[2].url_picture"
                    class="hidden mx-auto object-cover px-1 py-1" style="border-radius: 10px"
                    @load="onPollImageLoad(element.post_photos[2].id)" :src="compressedImage(element.post_photos[2])"
                    :ref="'poll-' + element.post_photos[2].id" />
                </div>
              </div>

              <!-- 4 pictures case -->

              <div class="mx-auto w-full" v-if="element.post_photos.length === 4">
                <div class="flex mx-auto">
                  <div class="w-1/2 my-auto">
                    <img v-if="element.post_photos[0].url_picture" :alt="element.text"
                      class="mx-auto object-cover px-1 py-1" src="/static/logo_square.png"
                      :ref="'loading-picture-poll-' + element.post_photos[0].id" />
                    <img :alt="element.text" v-if="element.post_photos[0].url_picture"
                      class="hidden mx-auto object-cover px-1 py-1" style="border-radius: 10px"
                      @load="onPollImageLoad(element.post_photos[0].id)" :src="compressedImage(element.post_photos[0])"
                      :ref="'poll-' + element.post_photos[0].id" />
                  </div>
                  <div class="w-1/2 my-auto">
                    <img v-if="element.post_photos[1].url_picture" :alt="element.text"
                      class="mx-auto object-cover px-1 py-1" src="/static/logo_square.png"
                      :ref="'loading-picture-poll-' + element.post_photos[1].id" />
                    <img :alt="element.text" v-if="element.post_photos[1].url_picture"
                      class="hidden mx-auto object-cover px-1 py-1" style="border-radius: 10px"
                      @load="onPollImageLoad(element.post_photos[1].id)" :src="compressedImage(element.post_photos[1])"
                      :ref="'poll-' + element.post_photos[1].id" />
                  </div>
                </div>
                <div class="flex mx-auto">
                  <div class="w-1/2 my-auto">
                    <img v-if="element.post_photos[2].url_picture" :alt="element.text"
                      class="mx-auto object-cover px-1 py-1" src="/static/logo_square.png"
                      :ref="'loading-picture-poll-' + element.post_photos[2].id" />
                    <img :alt="element.text" v-if="element.post_photos[2].url_picture"
                      class="hidden mx-auto object-cover px-1 py-1" style="border-radius: 10px"
                      @load="onPollImageLoad(element.post_photos[2].id)" :src="compressedImage(element.post_photos[2])"
                      :ref="'poll-' + element.post_photos[2].id" />
                  </div>
                  <div class="w-1/2 my-auto">
                    <img v-if="element.post_photos[3].url_picture" :alt="element.text"
                      class="mx-auto object-cover px-1 py-1" src="/static/logo_square.png"
                      :ref="'loading-picture-poll-' + element.post_photos[3].id" />
                    <img :alt="element.text" v-if="element.post_photos[3].url_picture"
                      class="hidden mx-auto object-cover px-1 py-1" style="border-radius: 10px"
                      @load="onPollImageLoad(element.post_photos[3].id)" :src="compressedImage(element.post_photos[3])"
                      :ref="'poll-' + element.post_photos[3].id" />
                  </div>
                </div>
              </div>
            </div>
          </template>
          <iframe :id="'video-player-' + element.id" v-if="element.type === 2" width="100%" height="100%"
            class="mx-auto px-2 py-2" :src="getYoutubeEmbedLink(element.url_video)" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
          <video v-if="element.type === 5" class="mx-auto px-2 py-1"
            :src="element.imgkit_url_video || element.url_video"
            :style="element.aspect_ratio < 1 ? 'max-height: 80vh' : ''" playsinline autoplay loop muted controls
            controlsList="nodownload"></video>
          <img :alt="element.text" v-if="element.type === 1 && element.url_picture"
            class="hidden mx-auto object-cover px-2 py-2" @load="onImageLoad(element)" :src="compressedImage(element)"
            :ref="element.id" style="aspect-ratio: 1" />

          <div class="px-5" v-if="element.type === 3">
            <p class="text-black dark:text-white text-md sm:text-lg" v-html="$detectHashtagsAndUsernames(element.text)">
            </p>
          </div>
          <template v-slot:footer>
            <div class="px-5" v-if="[1, 2, 5].includes(element.type)">
              <p class="text-black dark:text-white text-sm sm:text-md"
                v-html="$detectHashtagsAndUsernames(element.text)"></p>
            </div>

            <template v-if="element.type === 4">
              <div v-for="pollElement in element.questions" :key="pollElement.question.id">
                <p class="text-black dark:text-white text-sm md:text-md my-2 font-bold">
                  {{ pollElement.question.question }}
                </p>
                <div v-for="answer in pollElement.answers" :key="answer.answer.id" class="mb-3">
                  <div class="flex">
                    <div class="bg-transparent w-full rounded-lg relative flex justify-center border-primary-1100 py-3"
                      style="border-width: 1px">
                      <div class="absolute left-0 top-0 bg-primary-1100 rounded-lg h-full z-20 border-primary-1100"
                        :style="'width:' + answer.percentage + '%;'"></div>
                      <p class="mx-auto text-center my-auto text-black dark:text-white z-30 text-sm md:text-md">
                        {{ answer.answer.answer }}
                      </p>
                    </div>
                    <p class="text-center text-black dark:text-white text-sm md:text-md my-2 ml-1">
                      {{ answer.percentage }}%
                    </p>
                  </div>
                </div>
                <p class="text-center text-black dark:text-white text-sm md:text-md my-2 ml-1">
                  {{ element.answers }}
                  {{ $i18n.t("votes") }}
                </p>
              </div>
            </template>
          </template>
          <template v-if="index !== 0 && index % 4 === 0">
            <adsense :key="'feed-ad-' + index" data-ad-client="ca-pub-6627944524690313" data-ad-slot="5346751326"
              data-ad-format="auto" data-full-width-responsive="yes" data-ad-test="on" is-new-ads-code="yes" />
          </template>
        </t-card>
      </div>

      <t-button class="bg-primary-1000 mx-auto" v-if="posts.length > 0 && !reachedLast" @click="loadMore">{{
          $i18n.t("load_more_posts")
      }}</t-button>

      <div v-if="reachedLast">
        <p class="text-center mx-auto text-black dark:text-white">
          {{ $i18n.t("no_more_posts") }}
        </p>
      </div>
    </div>
    <template v-if="postID !== null">
      <LikedByModal :modal="likesModal" :postID="postID" @closeModal="closeLikesModal"
        @openProfile="openProfileFromLikesModal" />
    </template>
  </div>
</template>

<script>
import ProfilePicture from "@/components/user/ProfilePicture.vue"
import Likes from "@/components/post/likes.vue"
import LikedByModal from "@/components/post/LikedByModal.vue"
import ActionBar from "@/components/post/ActionBar.vue"
const notify = () => import("@/utils/notify.js")

export default {
  components: {
    ProfilePicture,
    Likes,
    LikedByModal,
    ActionBar
  },
  data() {
    return {
      page: 1,
      loading: true,
      posts: [],
      reachedLast: false,
      postID: 0,
      likesModal: false
    }
  },
  computed: {
    theme() {
      return this.$store.getters["getTheme"]
    },
    loggedUser() {
      return this.$store.getters["auth/getUser"]
    }
  },
  methods: {
    compressedImage(element) {
      return element.imgkit_url_picture
        ? element.imgkit_url_picture
        : element.url_picture
    },
    openProfileFromLikesModal() {
      this.likesModal = false
      this.$router.push(`/login`)
    },
    openLikesModal(likes) {
      // this.followListLoader = true
      this.postID = likes
      this.likesModal = true
    },
    closeLikesModal() {
      this.likesModal = false
      this.postID = 0
    },
    calculateHighNumber(number) {
      if (isNaN(number)) return 0
      if (Number(number) > 1000000) return (number / 1000000).toFixed(2) + "M"
      if (Number(number) > 1000) {
        return (number / 1000).toFixed(2) + "K"
      } else {
        return number
      }
    },
    getYoutubeEmbedLink(link) {
      let base_url = "https://www.youtube.com/embed/"
      if (link.includes("youtube")) {
        return (
          base_url +
          link.split("?v=")[1] +
          `?feature=oembed&enablejsapi=1&Origin=${window.location.host}`
        )
      } else if (link.includes("youtu.be")) {
        return (
          base_url +
          link.split("/")[3] +
          `?feature=oembed&enablejsapi=1&Origin=${window.location.host}`
        )
      } else {
        return ""
      }
    },
    onPollImageLoad(id) {
      if (this.$refs["loading-picture-poll-" + id][0])
        this.$refs["loading-picture-poll-" + id][0].classList.add("hidden")
      if (this.$refs["poll-" + id][0])
        this.$refs["poll-" + id][0].classList.remove("hidden")
    },

    onImageLoad(element) {
      if (this.$refs["loading-picture-" + element.id][0])
        this.$refs["loading-picture-" + element.id][0].classList.add("hidden")
      if (this.$refs[element.id][0])
        this.$refs[element.id][0].classList.remove("hidden")
    },
    openProfile(user) {
      this.$router.push(`/user/${user.username}`)
    },
    async loadMore() {
      this.page++
      this.loading = true
      await this.getPosts()
    },
    async getPosts() {
      this.$store
        .dispatch("global/getItems", {
          route: "/post/noauth/all",
          module: null,
          params: {
            order_key: "created_at",
            order_value: "desc",
            page: this.page,
            limit: 10
          }
        })
        .then((response) => {
          this.posts = this.posts.concat(response.data.data)
          if (response.data.data.length === 0) this.reachedLast = true
          this.$emit("finishLoading")
          this.loading = false
        })
        .catch((error) => {
          this.$emit("finishLoading")
          notify().then(({ notification }) => {
            notification("error", error.code, this.$snotify, this.$i18n.locale)
          })
        })
    }
  },
  async created() {
    if (this.loggedUser && this.loggedUser.id) this.$router.push("/home")
    // Set global theme
    const mediaQueryList = window.matchMedia("(prefers-color-scheme: dark)")
    mediaQueryList.addEventListener("change", (event) => {
      this.$store.dispatch("setTheme", event.matches ? "dark" : "light")
    })
    this.$store.dispatch("setTheme", mediaQueryList.matches ? "dark" : "light")

    this.$emit("startLoading")
    await this.getPosts()
    window.vueComponent = this

    window.onscroll = async function () {
      let total_scrollable_height =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight
      if (Math.round(window.scrollY) / total_scrollable_height > 0.7) {
        if (!this.vueComponent.reachedLast && !this.vueComponent.loading) {
          this.vueComponent.page++
          this.vueComponent.loading = true
          await this.vueComponent.getPosts()
        }
      }
    }
  },
  watch: {}
}
</script>
